import { render } from "./Header.vue?vue&type=template&id=1b810718"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=1b810718&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b810718"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b810718', __exports__)) {
    api.reload('1b810718', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=1b810718", () => {
    api.rerender('1b810718', render)
  })

}


export default __exports__